import { AppPreferencesModuleType } from '@/modules/app-preferences'

const AppPreferences: AppPreferencesModuleType = {
    set: (key: string, value: string, group?: string) => {},
}

export default AppPreferences
